module.exports = __webpack_public_path__ + "img/sankaku_62_blue.7fc1b20f.png";